<template lang="pug">
.v-footer-map.footer-map.footer__contact-map(v-if="map")
	img.footer__map-background-image(:src="backgroundImage" loading="lazy" alt="")
	.footer__map-header
		.footer__map-header-content
			.footer__map-header-icon
				img.footer__map-header-icon-image(v-if="map.image"
						:src="map.image"
						alt=""
						loading="lazy")
			.footer__map-header-text(v-if="map.text") {{map.text}}
	.footer__map-footer
		.footer__map-footer-text(v-if="map.address") {{map.address}}
		a.footer__map-footer-btn.btn.btn--black.btn--sm(v-if="map.button.text"
				:href="map.button.link"
				target="_blank") {{map.button.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin,
	],

	data() {
		return {
			map: null,
			backgroundImage: '/local/assets/images/map.webp'
		};
	},

	methods: {
		dataSet(data) {
			this.map = data;
		}
	}
};
</script>
